export default {
  toQueryWithPagination (obj, pagination, limit) {
    pagination = this.configurePagination(pagination, limit)
    pagination = this.toQuery(pagination)
    obj = this.toQuery(obj)
    return this.joinValues([obj, pagination])
  },

  toQuery (obj) {
    var entries = this.getEntries(obj)
    if (entries.length === 1) {
      return this.joinValue(entries[0])
    } else {
      entries = this.mapValues(entries)
    }

    return this.joinValues(entries)
  },

  getEntries (obj) {
    return Object.entries(obj)
  },

  mapValues (entries) {
    return entries.map(this.joinValue)
  },

  joinValue (el) {
    return el.join('=')
  },

  joinValues (values) {
    return values.join('&')
  },

  configurePagination (pagination, limit) {
    var pag = Object.assign({}, pagination)
    if (pag.per_page === undefined) pag.per_page = limit
    if (pag.current_page === undefined) pag.current_page = 1
    return { per_page: pag.per_page, current_page: pag.current_page }
  }
}



// WEBPACK FOOTER //
// ./src/utils/filter.js